export default "__VITE_ASSET__4259ee21__"